import styled from 'styled-components';

export const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
